import React from 'react';

export const LikeSolid = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.46102 9.5966C6.16805 9.85296 6 10.2233 6 10.6126V18.4384C6 19.3562 6.62459 20.1561 7.51493 20.3787L9.04456 20.7611C9.67912 20.9198 10.3308 21 10.9848 21H17.0457C18.8017 21 20.3524 19.8547 20.8688 18.1763L23.2036 10.5882C23.5994 9.30207 22.6377 8 21.2921 8H14.7454C14.4029 8 14.1802 7.63962 14.3333 7.33333L15.5242 4.95157C16.2022 3.59552 15.2162 2 13.7 2C12.9594 2 12.2769 2.40156 11.9172 3.04903L11.4919 3.81454C10.5047 5.59147 9.21783 7.18439 7.68804 8.52296L6.46102 9.5966ZM1 9C0.447715 9 0 9.44771 0 10V20C0 20.5523 0.447715 21 1 21H3C3.55228 21 4 20.5523 4 20V10C4 9.44772 3.55228 9 3 9H1Z"
      fill="currentColor"
    />
  </svg>
);
